// src/components/ShareArgumentLinkDialog.tsx
import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  InputBase,
  Paper,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

interface ShareArgumentLinkDialogProps {
  open: boolean;
  onClose: () => void;
  linkUrl: string;  // Changed from 'link' to 'linkUrl'
  handleCopyLink: () => void;  // Added this prop
}

const ShareArgumentLinkDialog: React.FC<ShareArgumentLinkDialogProps> = ({
  open,
  onClose,
  linkUrl,
  handleCopyLink
}) => {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async () => {
    handleCopyLink();
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          p: 2,
        },
      }}
    >
      <DialogContent>
        <Typography variant="h2" gutterBottom>
          Share with Your Opponent
        </Typography>
        

        <Typography variant="body1" color="text.primary" sx={{ mb: 3 }}>
          Share this unique link with the person you're arguing with. They'll be able to join and present their side.
        </Typography>

        <Paper
          sx={{
            display: 'flex'
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            value={linkUrl}
            readOnly
          />
        </Paper>

        <Button
          variant="contained"
          fullWidth
          onClick={handleCopy}
          color="primary"
        >
          {copied ? 'Link Copied!' : 'Copy Link'} {copied && <CheckIcon sx={{ ml: 1 }} />}
        </Button>

        <Button
          variant="text"
          fullWidth
          onClick={onClose}
          sx={{
            py: 1.5,
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // Custom shadow
            '&:hover': {
              boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.15)', // Enhanced shadow on hover
            },
          }}
        >
          Done
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default ShareArgumentLinkDialog;
